import React, { useEffect, useState } from "react";
import * as Highcharts from "highcharts";
import { formatDate, formatDateWithTemplate } from "@utils/format/date";
import { applyTip, wideFontSize32 } from "@utils/utils";
import Scrollbar from "../../../../../../../../utils/highchart/Scrollbar";
import BaseChartTooltipWithHeader, {
    HeaderTypes
} from "../../../../../../../../components/modules/dashboards/dashboardTooltips/TooltipVariants/BaseChartTooltipWithHeader/BaseChartTooltipWithHeader";
import { formatNumber2d } from "@utils/format/number";
import { commonChartOptions } from "../../utils/common";
import { PlanFactDetalization } from "../../../../../../../../store/reducers/dashboard/works/detalization";
import { XAxisOptions } from "highcharts";
import LinearChart from "../../../../../../../../components/modules/dashboards/сharts/defaultCharts/linearChart/LinearChart";
import colors from "@infobis/ui-styles-utils/colors";

type CumulativeChartProps = {
    isFull: boolean
    planFactDetalization: PlanFactDetalization
    weatherAxis: XAxisOptions
}

const CumulativeChart = (props: CumulativeChartProps) => {
    const {
        isFull,
        weatherAxis,
        planFactDetalization
    } = props;

    const [chartOptions, setChartOptions] = useState<Highcharts.Options>({ title: { text: '' }, credits: { enabled: false } });

    useEffect(() => {
        const defaultOptions: Highcharts.Options = {
            ...commonChartOptions,
            xAxis: [
                {
                    type: 'datetime',
                    labels: {
                        formatter: function () {
                            return formatDateWithTemplate(+this.value, isFull ? 'DD.MM' : 'HH:mm')
                        },
                        autoRotation: undefined,
                        style: {
                            fontSize: wideFontSize32(),
                            color: colors.TYPO_SECONDARY
                        },
                    },
                    scrollbar: Scrollbar(),
                    lineColor: colors.BG_BORDER,
                    tickColor: colors.BG_BORDER
                },
                { ...weatherAxis, type: 'datetime' }
            ],
            tooltip: applyTip((ctx) =>
                <BaseChartTooltipWithHeader
                    header={{ type: HeaderTypes.ndvi, title: formatDate(new Date(ctx.x as number), isFull ? 'dd.LL' : 'HH:mm') }}
                    elements={ctx.points?.map((point, id) => ({
                        color: point.color as string,
                        name: point.series.name,
                        value: `${formatNumber2d(point.y)} Га`,
                        id: `${point.series.name}-${id}`
                    })) || []}
                />, { shared: true, outside: false }
            ),
            yAxis: {
                min: 0,
                endOnTick: false,
                title: {
                    text: ''
                },
                gridLineWidth: 1,
                labels: {
                    formatter: (ctx) => formatNumber2d(Number(ctx.value)),
                    style: {
                        fontSize: wideFontSize32()
                    }
                }
            },
            plotOptions: {
                series: {
                    events: {
                        legendItemClick: function (e) {
                            return false
                        }
                    },
                    marker: {
                        symbol: 'circle'
                    },
                    borderWidth: 0,
                },
                column: {
                    shadow: false,
                    borderWidth: 0,
                }
            },
            series: [
                {
                    name: 'План',
                    color: '#86CE52',
                    type: 'line',
                    data: planFactDetalization.plan.map(i => [i.date, +((i.cultivatedArea).toFixed(2))]),
                    marker: {
                        enabled: false,
                        fillColor: undefined
                    }
                },
                {
                    name: 'Факт',
                    color: '#FE7C66',
                    type: 'line',
                    data: planFactDetalization.fact.map(i => [i.date, i.cultivatedArea]),
                    marker: {
                        enabled: false,
                        fillColor: undefined
                    }
                }
            ],
        }

        setChartOptions(defaultOptions);

    }, [planFactDetalization, isFull, weatherAxis])

    return (
        <LinearChart
            options={chartOptions}
            zoomAxis={'xAxis'}
        />
    )
}

export default CumulativeChart;